<template>
  <div class="special-home-menu">
    <div class="special-home-menu-component hidden">
      <div class="component-background" @click="close" />
      <div class="wrapper" :class="theme">
        <!-- <span
          class="tag is-warning release-notes"
          @click="goto('release_notes')"
          >Release Notes</span
        > -->
        <i class="fa fa-redo-alt has-text-grey" @click="spinReload" />
        <i class="fa fa-chevron-down fa-lg" @click="close" />
        <!-- <span class="toggle">
          <img src="/img/home2/half.svg" @click="toggleTheme" />
        </span> -->
        <span class="version has-text-grey">{{ environment }}</span>
        <!-- <i class="fa fa-share-alt fa-lg has-text-link" @click="openQRShare" /> -->
        <span class="share link has-text-link" @click="openQRShare">Share</span>

        <div class="column" @click="clearCacheAndReload">
          <img src="/img/home2/download.svg" />
          <p class="has-text-info has-text-weight-medium">
            v{{ $store.state.version }}
          </p>
        </div>
        <div v-if="isSuper" class="column" @click="goto('user_lookup')">
          <!-- @click="goto('control?tab=transaction-edit')" -->
          <img src="/img/home2/actress.svg" class="svg-white" />
          <p>Users</p>
        </div>
        <div v-if="isSuper" class="column" @click="showTransactions">
          <img src="/img/home2/graphic.svg" />
          <p>Transactions</p>
        </div>
        <div class="column" @click="openLanguageSelector">
          <img src="/img/home2/translation.svg" />
          <p>Language</p>
        </div>
        <!-- <div class="column" @click="openQRShare">
          <img src="/img/home2/share.svg" />
          <p>Share</p>
        </div> -->
        <div class="column" @click="openQRGenerator">
          <img src="/img/home2/qr-create.svg" />
          <p>Create QR</p>
        </div>
        <div class="column" @click="showNetworkErrors">
          <img src="/img/home2/wireless-router.svg" />
          <p>Network</p>
        </div>
        <!-- <div class="column" @click="gotoDelay('geometry')">
          <img src="/img/home2/compass.svg" />
          <p>Draw</p>
        </div> -->
        <!-- <div
          class="column"
          @click="gotoDelay('/profile?tab=trips&tab2=Upcoming')"
        >
          <img src="/img/home2/squirrel.svg" class="wiggle" />
          <p>Trips</p>
        </div> -->
        <div v-if="!isSuper" class="column" @click="$store.commit('incrementSecret')">
          <img src="/img/home2/rabbit-magic.svg" />
          <p>Hide ({{ $store.state.secret }})</p>
        </div>
      </div>
    </div>
    <QRCodeGenerator />
    <TUKAppShareModal />
    <!-- <MainQRModal /> -->
    <!-- <WorkflowTypeStatsModal /> -->

  </div>
</template>

<script>
import EventBus from "../eventBus.js";
import QRCodeGenerator from "@/components/QRCodeGenerator.vue";
// import MainQRModal from "@/components/MainQRModal.vue";
import TUKAppShareModal from "@/components/TUKAppShareModal.vue";
// import WorkflowTypeStatsModal from "@/components/WorkflowTypeStatsModal.vue";
import { sounds } from "../functions.js";

export default {
  name: "SpecialHomeMenu",
  components: {
    QRCodeGenerator,
    // MainQRModal,
    TUKAppShareModal,
    // WorkflowTypeStatsModal,
  },
  data() {
    return {
      // theme: "is-dark",
      showRecentTransactions: false,
    };
  },
  computed: {
    isSuper() {
      return this.$store.getters.isSuperUser;
    },
    environment() {
      return process.env.VUE_APP_TITLE;
    },
    theme() {
      return this.$store.state.theme;
    },
  },
  mounted() {
    EventBus.$on("CLOSE_HOME_PANELS", () => this.close());
  },
  deactivated() {
    this.close();
  },
  methods: {
    close() {
      this.hideComponent(".special-home-menu-component");
    },
    // toggleTheme() {
    // if (this.theme) this.theme = null;
    // else this.theme = "is-dark";
    // },
    spinReload() {
      // this.$swal({
      //   html: `<img src='/img/home2/spinner.svg' style='height:100px; width:100px; animation: rotation 0.6s infinite ease; filter: drop-shadow(1px 1px 1px gold);' />`,
      //   showConfirmButton: false,
      //   customClass: { popup: "round-swal" },
      // });
      EventBus.$emit("UPDATING_APP");
      setTimeout(() => this.refreshPage(), 1250);
    },
    showTransactions() {
      // this.displayModal(".workflow-type-stats-modal");
      // EventBus.$emit("WORKFLOW_TYPE_STATS");
      this.goto("super_ops");
      // this.showRecentTransactions = true;
    },
    openQRGenerator() {
      this.displayModal(".qr-code-generator-modal");
    },
    openQRShare() {
      // this.displayModal(".share-qr-modal");
      this.displayModal(".tuk-app-share-modal");
    },
    testNotifications() {
      if (this.$store.getters.isLoggedIn) {
        sounds("collect1");
        setTimeout(() => {
          this.sendPushNotification("ขอบคุณเพื่อนของฉัน 🙏🏽", this.userID());
        }, 1500);
      } else {
        sounds("unsafe"); // not logged in
      }
    },
    showNetworkErrors() {
      var errs = this.$store.state.networkErrors;
      var text = "";
      errs.forEach((o) => {
        var endpoint = o.url.split("/tuk/")[1];
        var method = o.method;
        var createdAt = new Date(o.created_at).toLocaleString();
        text = `<p style='margin:9px 0'><code style='margin-left:-6px'>${createdAt}</code><br><b>${method.toUpperCase()}</b> ${endpoint}</p>${text}`;
      });
      this.$swal({
        html: `<strong>Network Errors</strong><br><div style="text-align:left; white-space:pre-line; font-size:0.8em">${text}</div>`,
        showConfirmButton: false,
        showCloseButton: true,
      });
    },
  },
};
</script>

<style scoped>
.hidden {
  display: none;
}

.component-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.25);
  z-index: 2;
}

.wrapper {
  position: absolute;
  /* bottom: 70px; */
  bottom: 0;
  width: 100vw;
  backdrop-filter: blur(8px);
  background-color: rgba(255, 255, 255, 0.85);
  /* background-color: #333;
  color: white; */
  padding-bottom: 20px;
  padding-top: 14px;
  padding-left: 10px;
  padding-right: 10px;
  /* box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.35); */
  box-shadow: 0px 0px 16px white;
  z-index: 5;
  border-top-right-radius: 12px;
  border-top-left-radius: 12px;
  /* overflow-x: auto; */
  /* white-space: nowrap; */
  /* background-image: url("/img/home2/home-dots-pattern.png");
  background-size: contain;
  background-position: center; */
}

.dark {
  /* background-color: #1c37bd; */
  /* background-color: rgba(17, 34, 51, 0.8); */
  background-color: #1f1b24;
  color: white;
}

.column {
  display: inline-block;
  width: 100px;
  padding: 0 0;
  margin-bottom: 10px;
}

.column img {
  height: 40px;
}

.fa-chevron-down {
  position: absolute;
  right: 0;
  top: 0;
  padding: 6px;
  margin: 6px;
  /* color: #f5d252; */
  /* text-shadow: 1px 0px 3px rgba(0, 0, 0, 0.3), 0 0 1px blue; */
}

.fa-redo-alt {
  position: absolute;
  left: 0;
  top: 0;
  padding: 6px;
  margin: 6px;
  /* color: #f5d252;
  text-shadow: 1px 0px 1px rgba(0, 0, 0, 0.3), 0 0 1px blue; */
}

.version {
  position: absolute;
  left: 0;
  bottom: 0;
  padding: 10px;
  font-size: 0.8em;
  font-weight: 900;
}

.fa-share-alt {
  position: absolute;
  right: 0;
  bottom: 0;
  padding: 6px;
  margin: 6px;
}

.share {
  position: absolute;
  right: 0;
  bottom: 0;
  /* padding: 6px; */
  margin: 10px;
  line-height: 1.2em;
  font-size: 0.9em;
  font-weight: 500;
}

.toggle {
  position: absolute;
  right: 0;
  bottom: 0;
  padding: 6px;
  opacity: 0.5;
}

.toggle img {
  height: 22px;
}

.wiggle:active {
  transform: rotate(330deg);
  -webkit-transform: rotate(330deg);
  -ms-transform: rotate(330deg);
}

.dark img {
  filter: invert(100%) sepia(33%) saturate(0%) hue-rotate(319deg) brightness(107%) contrast(101%);
}

img:active {
  transform: scaleY(0.95);
}

.release-notes {
  position: absolute;
  margin-top: -50px;
  left: 6px;
  opacity: 0.95;
  font-size: 0.9em;
  /* line-height: 1em; */
  padding: 6px;
}
</style>

<style>
.system-stats-swal {
  border-radius: 25px;
  background-color: #333;
}

.ddd strong {
  color: white;
}
</style>